var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.booking{fill:url(#booking-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "booking-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83f9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36719,
    stopColor: "#32d98f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#17ce81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02739f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "booking",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M57.96759,51.38925l-4.55822-.91091-2.27491-4.05374c-.49709-.88562-1.77195-.88562-2.26894,0l-2.27491,4.05374-4.55822.91091c-.9959.19902-1.3899,1.41145-.70117,2.15784l3.15233,3.41621-.54232,4.6166c-.11848,1.00865.91294,1.75809,1.83559,1.33364l4.22311-1.94233,4.22321,1.94233c.92265.42445,1.95397-.32499,1.83549-1.33364l-.54222-4.6166,3.15233-3.41621c.68873-.7464.29473-1.95883-.70117-2.15784Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M66.28125,71.23633h-32.5625c-3.82031,0-6.92871-3.1084-6.92871-6.92871v-28.61523c0-3.82031,3.1084-6.92871,6.92871-6.92871h32.5625c3.82031,0,6.92871,3.1084,6.92871,6.92871v28.61523c0,3.82031-3.1084,6.92871-6.92871,6.92871ZM33.71875,31.76367c-2.16602,0-3.92871,1.76221-3.92871,3.92871v28.61523c0,2.1665,1.7627,3.92871,3.92871,3.92871h32.5625c2.16602,0,3.92871-1.76221,3.92871-3.92871v-28.61523c0-2.1665-1.7627-3.92871-3.92871-3.92871h-32.5625Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M35.03821,30.26345h29.92359c3.72455,0,6.74841,3.02386,6.74841,6.74841v3.46809H28.2898v-3.46809c0-3.72455,3.02386-6.74841,6.74841-6.74841Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingReviewsScraper);
export default __webpack_public_path__ + "static/media/booking-reviews-scraper.d1dc537f6e9bef6e573ae7cf85f6a638.svg";
export { ForwardRef as ReactComponent };